module.exports = __webpack_public_path__ + "static/media/excerpt_overlay_old.9a574692.png";